import React from "react";
import { useNavigate } from "react-router-dom";

export default function Services() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white p-6 relative flex items-center justify-center">
      {/* Main Content */}
      <div className="text-white max-w-3xl p-8 rounded-2xl shadow-lg">
        <h1 className="text-3xl font-bold mb-4 text-white">Services</h1>
        <div className="space-y-4 text-lg leading-relaxed">
          <p>
            <span className="font-semibold">WEBSITE USE:</span> AICA as an AI
            powered Care Assistant is priced at <b>Rs 999/- onwards</b>.
          </p>
          <p>
            <span className="font-semibold">Billing Information:</span> AICA
            Healthtech Pvt Ltd, 1st Floor, D-48, Ajay Enclave, New Delhi-110018
          </p>
        </div>
      </div>

      {/* Back to Home at bottom */}
      <div className="absolute bottom-6 w-full flex justify-center">
        <button
          onClick={() => navigate("/")}
          className="bg-white text-teal-600 px-6 py-2 rounded-full shadow hover:bg-gray-100 transition"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
